<template>

    <transition-group class="tips__container" name="tips__slide">

        <template v-for="(tip, index) in tips">

            <div v-if="tipsIndex === index" v-bind:key="index" class="tips">

                <div class="tips__left">

                    <img :src="`/img/tips/twemoji-tips-${ tipsIndex + 1 }.svg`" :class="isDesktop ? 'img__32' : 'img__24'">

                </div>

                <div class="tips__right">

                    <p class="text-baseSemibold-2 color__aquamarine">{{ $t('global_did_you_know_title') }}</p>

                    <markdown :text="tip" class="text-baseRegular-2 color__moon"></markdown>

                </div>

            </div>

        </template>

    </transition-group>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'tips-fetch',

    components: {Markdown},

    data() {
        return {
            tipsIndex: 0,
            tips: []
        }
    },

    mounted() {

        this.tipsDance()

        this.getTips()

    },

    methods: {

        tipsDance() {

            const self = this

            setInterval(function () {

                self.tipsIndex = self.tipsIndex >= self.tips.length - 1 ? 0 : self.tipsIndex + 1

            }, 8000)

        },

        getTips() {

            let index = 1
            let bool = true

            while (bool) {

                if (this.$te(`fetch_tips_${index}`)) {

                    this.tips.push(this.$t(`fetch_tips_${index}`))

                } else {
                    bool = false
                }

                index++

            }

        }

    }

}

</script>

<style lang="scss" scoped>

.tips {
    position: absolute;
    height: 86px;
    width: 100%;
    padding: 16px 16px 16px 0;
    display: flex;
    flex-direction: row;
    border-radius: 12px;
    box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.05);
    background-color: $white;

    &__container {
        position: relative;
        min-height: 52px;
        width: 100%;
        height: 102px;
    }

    &__left {
        min-width: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__right {
        display: flex;
        flex-direction: column;
        text-align: left;
        justify-content: center;
    }

    &__slide-enter-active {
        animation: anim-slide-in 1s cubic-bezier(.5, 0, .25, 1);
        @media screen and (min-width: $above-tablet-length) {
            animation: anim-desktop-slide-in .6s ease-in-out .4s;
            opacity: 0;
        }
    }
}

@keyframes anim-slide-in {
    0% {
        transform: translateX(500px)
    }

    100% {
        transform: translateX(0)
    }
}

@keyframes anim-desktop-slide-in {
    0% {
        transform: translateY(48px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.tips__slide-leave-active {
    animation: anim-slide-out 1s cubic-bezier(.5, 0, .25, 1);
    @media screen and (min-width: $above-tablet-length) {
        animation: anim-desktop-slide-out .6s ease-in;
    }
}

@keyframes anim-slide-out {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(-500px)
    }
}

@keyframes anim-desktop-slide-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-96px);
        opacity: 0;
    }
}

</style>
